export const UP    = 38;
export const DOWN  = 40;
export const SPACE = 32;
export const ENTER = 13;
export const ESC   = 27;